/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Generic dashboard-level filter control (values resolved dynamically later).
 * @export
 * @interface Control
 */
export interface Control {
    /**
     * Control identifier (e.g. 'platform', 'instance')
     * @type {string}
     * @memberof Control
     */
    key: string;
    /**
     * Displayed label (e.g. 'Platform', 'Deployment')
     * @type {string}
     * @memberof Control
     */
    label: string;
    /**
     * Underlying data dimension / SDP column
     * @type {string}
     * @memberof Control
     */
    dimension: string;
    /**
     * How the control is rendered in the UI (dropdown, textfield, …)
     * @type {string}
     * @memberof Control
     */
    type?: ControlTypeEnum;
    /**
     * Parent control keys forming the cascade
     * @type {Array<string>}
     * @memberof Control
     */
    dependsOn?: Array<string>;
    /**
     * Whether multi-select is allowed
     * @type {boolean}
     * @memberof Control
     */
    multiple?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    maxSelections?: number | null;
}


/**
 * @export
 */
export const ControlTypeEnum = {
    Dropdown: 'dropdown',
    Textfield: 'textfield'
} as const;
export type ControlTypeEnum = typeof ControlTypeEnum[keyof typeof ControlTypeEnum];


/**
 * Check if a given object implements the Control interface.
 */
export function instanceOfControl(value: object): value is Control {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('dimension' in value) || value['dimension'] === undefined) return false;
    return true;
}

export function ControlFromJSON(json: any): Control {
    return ControlFromJSONTyped(json, false);
}

export function ControlFromJSONTyped(json: any, ignoreDiscriminator: boolean): Control {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'dimension': json['dimension'],
        'type': json['type'] == null ? undefined : json['type'],
        'dependsOn': json['dependsOn'] == null ? undefined : json['dependsOn'],
        'multiple': json['multiple'] == null ? undefined : json['multiple'],
        'maxSelections': json['maxSelections'] == null ? undefined : json['maxSelections'],
    };
}

export function ControlToJSON(json: any): Control {
    return ControlToJSONTyped(json, false);
}

export function ControlToJSONTyped(value?: Control | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'dimension': value['dimension'],
        'type': value['type'],
        'dependsOn': value['dependsOn'],
        'multiple': value['multiple'],
        'maxSelections': value['maxSelections'],
    };
}

